import { ContentSection } from "../layout/ContentSection"
import { Emphasize, Skill } from "../ui/CustomTypography"
import { Typography } from "@mui/material"

// anniversary-aware: career started 2017-07-01, so the count ticks up in
// July, not January
const yearsOfExperience = () => {
    const now = new Date()
    const start = new Date(2017, 6, 1)
    const years = now.getFullYear() - start.getFullYear()
    const beforeAnniversary =
        now.getMonth() < start.getMonth() ||
        (now.getMonth() === start.getMonth() && now.getDate() < start.getDate())
    return beforeAnniversary ? years - 1 : years
}

export const ProfileSummary = () => {
    const years = yearsOfExperience()
    return (
        <ContentSection title="Profile Summary">
            <Typography variant="body1">
                <Emphasize>Senior Data Engineer, {years} years</Emphasize> across fintech and energy:
                data platforms, batch and streaming pipelines, and real-time services on{" "}
                <Skill>GCP</Skill> across SQL and NoSQL systems. At ABACUS digital, built the cloud
                landing zone solo (<Skill>Terraform</Skill>/Terragrunt, network, <Skill>IAM</Skill>,
                security) and the data platform on top; resilient services cut downtime by ~70%. Turns
                repeated work into reusable tools: internal <Skill>Python</Skill> packages, shared{" "}
                <Skill>CI/CD</Skill> patterns, open source projects, all built for maintainability and
                repeatability.
            </Typography>
        </ContentSection>
    )
}
